export const centsToDollars = (cents) => cents / 100

export const centsToDollarsTrunc = (cents) => {
  return Math.trunc(centsToDollars(cents))
}

export const centsToPrettyDollars = (cents) => {
  return (cents / 100).toFixed(2)
}
